import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import ChartTooltip from 'components/molecules/Tooltips/ChartTooltip/ChartTooltip';

const StyledDealflowTooltip = styled(ChartTooltip)`
  .DealflowTooltip {
    &-content {
      padding: ${props => props.theme.spacing(0.5)};
      min-width: ${props => props.theme.layout(160)};
      
      .Badge {
        .MuiBadge-badge {
          font-size: ${props => props.theme.fontSize(11)};
          height: ${props => props.theme.layout(16)};
        }
      }

      .Span {
        font-size: ${props => props.theme.fontSize(13)};
        margin-left: 0;
        margin-right: ${props => props.theme.layout('1sp')};
      }
      
      .Divider {
        margin-top: ${props => props.theme.spacing(0.75)};
        margin-bottom: ${props => props.theme.spacing(0.75)};
      }

      .title {
        display: flex;
        align-items: center;
        padding: ${props => props.theme.spacing(0.5)} 0;
        ${props => props.theme.font2Css('caption')};
        &:not(:has(.Icon, .Avatar)) {
          font-weight: 500;
        }
        
        .DealflowIcon {
          font-size: inherit;
          height: ${props => props.theme.layout(12)};
          width: ${props => props.theme.layout(12)};
          margin-right: ${props => props.theme.layout('0.5sp')};

          &.Avatar {
            font-size: ${props => props.theme.fontSize(13)};
            height: ${props => props.theme.layout(16)};
            width: ${props => props.theme.layout(16)};
          }
        }
        
        .Span {
          flex-grow: 1;
        }
      }
      
      .Divider {
        margin-left: ${props => props.theme.layout('-1sp')};
        margin-right: ${props => props.theme.layout('-1sp')};
      }
    }
  }

  &.DealflowTooltip-extended, &.DealflowTooltip-members {
    .DealflowTooltip-content {
      min-width: ${props => props.theme.layout(180)};
      
      .extended {
        display: flex;
        flex-direction: column;

        .status, .leader {
          display: flex;
          align-items: center;

          .Span {
            flex-grow: 1;
            font-weight: 400;
          }

          .Badge {
            .MuiBadge-badge {
              color: ${props => props.theme.property('palette.text.primary')};
            }
          }
        }
      }
    }
  }
  
  &.DealflowTooltip-extended {
    .DealflowTooltip-content {
      .title {
        ${props => props.theme.font2Css('subtitle2')};

        .Span {
          font: inherit;
          color: ${props => props.theme.property('palette.text.primary')};
        }
        
        .DealflowIcon {
          font-size: inherit;
          height: ${props => props.theme.layout(16)};
          width: ${props => props.theme.layout(16)};

          &.Avatar {
            font-size: ${props => props.theme.fontSize(13)};
            height: ${props => props.theme.layout(16)};
            width: ${props => props.theme.layout(16)};
          }
        }
      }

      .extended {
        font-size: ${props => props.theme.fontSize(13)};
        padding: ${props => props.theme.layout('0.5sp')} 0;
        gap: ${props => props.theme.layout('1sp')};

        .Avatar {
          margin-right: ${props => props.theme.layout('0.5sp')};
        }
      }
    }
  }
  
  &.DealflowTooltip-members {
    .DealflowTooltip-content {
      min-width: ${props => props.theme.layout(200)};
      
      .title {
        ${props => props.theme.font2Css('subtitle2')};

        .Span {
          font: inherit;
          color: ${props => props.theme.property('palette.text.primary')};
        }
        
        .DealflowIcon {
          font-size: inherit;
          height: ${props => props.theme.layout(20)};
          width: ${props => props.theme.layout(20)};
          margin-right: ${props => props.theme.layout('0.75sp')};

          &.Avatar {
            font-size: ${props => props.theme.fontSize(13)};
            height: ${props => props.theme.layout(16)};
            width: ${props => props.theme.layout(16)};
          }
        }
      }
      
      .extended {
        ${props => props.theme.font2Css('subtitle2')};
        padding: ${props => props.theme.layout('0.25sp')} 0;
        gap: ${props => props.theme.layout('1.5sp')};

        .Avatar {
          margin-right: ${props => props.theme.layout('1sp')};
        }
      }
    }
  }

  &.DealflowTooltip-minimal {
    .DealflowTooltip {
      &-content {
        min-width: unset;
        padding: 0;

        .title {
          padding: 0;
        }
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledDealflowTooltip.propTypes = {
  theme: PropTypes.object
};

export default StyledDealflowTooltip;
